import {authenticationStatus} from "../store/stores";

class Cookie {

    getCookie(name: string) :string | boolean {

        let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {

            return match[2];
        } else {
            //We put the property authenticated at false
            let authStatus = {authenticated: false}
            authenticationStatus.set(authStatus)
            return false;
        }
    }
}

export {Cookie};